import { fetchData, postData, putData, patchData } from "./apis";

const path = "/settings";

export const getLocationApi = (location) => {
  let endPoint = `${path}/get-locations`;
  return postData(endPoint, location);
};

export const getUserApi = (value) => {
  let endPoint = `${path}/get-users`;
  return postData(endPoint, value);
};
export const cloneRoleApi = (value) => {
  let endPoint = `${path}/clone-role`;
  return postData(endPoint, value);
};

export const getEmployeesApi = (value) => {
  let endPoint = `${path}/get-employees`;
  return postData(endPoint, value);
};

export const getAccountByTypeApi = (value) => {
  let endPoint = `${path}/get-accounts-by-type`;
  return postData(endPoint, value);
};

export const getWarehouseApi = (value) => {
  let endPoint = `${path}/get-warehouses`;
  return postData(endPoint, value);
};

export const getPatientApi = (value) => {
  let endPoint = `${path}/get-patient`;
  return postData(endPoint, value);
};

export const getDoctorApi = (value) => {
  let endPoint = `${path}/get-doctor`;
  return postData(endPoint, value);
};

export const warehouseDisableRestoreApi = (value) => {
  let endPoint = `${path}/warehouse-disable-restore`;
  return postData(endPoint, value);
};

export const warehousCuApi = (value) => {
  let endPoint = `${path}/warehouse-cu`;
  return postData(endPoint, value);
};

export const getUserDisableRestoreApi = (value) => {
  let endPoint = `${path}/user-disable-restore`;
  return postData(endPoint, value);
};

export const userEmailSentApi = (value) => {
  let endPoint = `${path}/user-gmail-send`;
  return postData(endPoint, value);
};

export const signUpApi = (value) => {
  let endPoint = `${path}/signup`;
  return postData(endPoint, value);
};

export const getInstitutionApi = () => {
  let endPoint = `${path}/get-institution`;
  return fetchData(endPoint);
};

export const getRolesApi = (value) => {
  let endPoint = `${path}/get-roles`;
  return postData(endPoint, value);
};

export const getRolesListApi = (value) => {
  let endPoint = `${path}/user-roles-list`;
  return postData(endPoint, value);
};

export const getTabsApi = (value) => {
  let endPoint = `${path}/get-tabs`;
  return postData(endPoint, value);
};

export const saveRoleApi = (value) => {
  let endPoint = `${path}/save-role`;
  return postData(endPoint, value);
};

export const saveRoleAccessApi = (value) => {
  let endPoint = `${path}/save-role-access`;
  return postData(endPoint, value);
};

export const getInstitutionModuleSettingsApi = () => {
  let endPoint = `${path}/get-institution-module-settings`;
  return postData(endPoint, {});
};

export const saveInstitutionModuleSettingsApi = (value) => {
  let endPoint = `${path}/save-institution-module-settings`;
  return postData(endPoint, value);
};

export const createTagGroupApi = (value) => {
  let endPoint = `${path}/create-tag-group`;
  return postData(endPoint, value);
};

export const getTagGroupNameApi = (value) => {
  let endPoint = `${path}/get-tag-groupname`;
  return postData(endPoint, value);
};

export const createTagFieldApi = (value) => {
  let endPoint = `${path}/create-tagfield`;
  return postData(endPoint, value);
};

export const getTagFieldApi = () => {
  let endPoint = `${path}/get-tag-fieldname`;
  return postData(endPoint);
};

export const getTagFieldApiofgroupid = (value) => {
  let endPoint = `${path}/get-tag-fieldname-ofmatching-groupid`;
  return postData(endPoint, value);
};

export const deleteTagFieldApi = (value) => {
  let endPoint = `${path}/delete-TagField`;
  return postData(endPoint, value);
};

export const branchCUApi = (value) => {
  let endPoint = `${path}/branch-cu`;
  return postData(endPoint, value);
};

export const branchDisableRestoreApi = (value) => {
  let endPoint = `${path}/branch-disable-restore`;
  return postData(endPoint, value);
};

export const sentSmsApi = (value) => {
  let endPoint = `${path}/sent-sms`;
  return postData(endPoint, value);
};

export const getAccountBySeachApi = (value) => {
  let endPoint = `${path}/get-accounts-by-search`;
  return postData(endPoint, value);
};

export const getInvoiceBySeachApi = (value) => {
  let endPoint = `${path}/get-invoice-by-search`;
  return postData(endPoint, value);
};

export const switchBranchApi = (value) => {
  let endPoint = `${path}/switch-branch`;
  return postData(endPoint, value);
};

export const getBranchApi = (value) => {
  let endPoint = `${path}/get-branches`;
  return postData(endPoint, value);
};

export const getAdminAccess = () => {
  let endPoint = `${path}/user-adminroles-access-subscriptionwise`;
  return postData(endPoint);
};

export const getAccerssTypeApi = (value) => {
  let endPoint = `${path}/get-access-type`;
  return postData(endPoint, value);
};

export const getCustomersApi = (value) => {
  let endPoint = `${path}/get-customers`;
  return postData(endPoint, value);
};

export const saveAccessApi = (value) => {
  let endPoint = `${path}/save-access`;
  return postData(endPoint, value);
};

export const getAccessApi = (value) => {
  let endPoint = `${path}/get-access`;
  return postData(endPoint, value);
};

export const getActivitiesApi = (params) => {
  let endPoint = `${path}/get-activities`;
  return fetchData(endPoint, { params });
};

export const getRecentActivitiesApi  = () => {
  let endPoint = `${path}/recent-activities`;
  return fetchData(endPoint);
};

export const getExpiryNotificationApi = (params = {}) => {
  let endPoint = `${path}/get-expiry-notifications`;
  return fetchData(endPoint, { params });
};

export const getMyTabAccessApi = () => {
  let endPoint = `${path}/my-tab-access`;
  return fetchData(endPoint);
};

export const searchApi = (value) => {
  let endPoint = `${path}/search`;
  return postData(endPoint, value);
};

export const getInstitutionDetailsApi = () => {
  let endPoint = `${path}/institution-details`;
  return fetchData(endPoint);
};

export const getCountDetailsApi = (value) => {
  let endPoint = `${path}/get-count-details`;
  return postData(endPoint, value);
};

export const getSubscriptionApi = () => {
  let endPoint = `${path}/getsubscription`;
  return fetchData(endPoint);
};

// export const saveInstitutionApi = async (formData, token) => {
//   return axios.post(`${BACKEND_API_URL}/settings/save-institution`, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       "auth-token": token,
//     },
//   });
// };

export const saveInstitutionApi = (value) => {
  let endPoint = `${path}/save-institution`;
  return postData(endPoint, value);
};

export const saveInstituionDetailsApi = (value) => {
  let endPoint = `${path}/create-institution-details`;
  return postData(endPoint, value);
};
export const verifyPasswordApi = (payload) => {
  let endPoint = `${path}/verify-password`;
  return postData(endPoint, payload);
};
export const singleInstitutionDetailApi = (value) => {
  let endPoint = `${path}/single-institution-detail`;
  return postData(endPoint, value);
};

export const updateInstitutionStatusApi = (value) => {
  let endPoint = `${path}/update-institution-status`;
  return postData(endPoint, value);
};

export const updateOnboardingStatusApi  = (value) => {
  let endPoint = `${path}/onboarding-status`;
  return patchData(endPoint, value);
};

export const updateInstitutionDetailsApi = (value) => {
  let endPoint = `${path}/update-institution-details`;
  return putData(endPoint, value);
};

export const updatePasswordApi = (value) => {
  let endPoint = `${path}/update-password`;
  return postData(endPoint, value);
};

export const getUserRoleSubscriptionWiseListApi = (value) => {
  let endPoint = `${path}/user-subscription-based-list`;
  return postData(endPoint, value);
};

export const userSignout = (value) => {
  let endPoint = `${path}/signout`;
  return postData(endPoint, value);
};

export const userUpdateApi = (value) => {
  let endPoint = `${path}/user-update`;
  return postData(endPoint, value);
};

export const getUsersBranchWiseApi = (value) => {
  let endPoint = `${path}/get-users-branch`;
  return postData(endPoint, value);
};

export const getAllUsersWiseApi = (value) => {
  let endPoint = `${path}/get-all-users`;
  return postData(endPoint, value);
};

export const getAccountsApi = (value) => {
  let endPoint = `${path}/get-accounts`;
  return postData(endPoint, value);
};

export const createClinic = (value) => {
  let endPoint = `${path}/create-clinic`;
  return postData(endPoint, value);
};

export const createDoctor = (value) => {
  let endPoint = `${path}/create-doctor`;
  return postData(endPoint, value);
};

export const getClinic = (value) => {
  let endPoint = `${path}/get-clinic`;
  return postData(endPoint, value);
};

export const createInsurance = (value) => {
  let endPoint = `${path}/create-insurance-company`;
  return postData(endPoint, value);
};

export const getInsuranceCompany = (value) => {
  let endPoint = `${path}/get-insurance-company`;
  return postData(endPoint, value);
};

export const createPatient = (value) => {
  let endPoint = `${path}/create-patient`;
  return postData(endPoint, value);
};

export const getLoginHistory = () => {
  let endPoint = `${path}/login-history/`;
  return fetchData(endPoint);
};

export const sendEmailApi = (value) => {
  let endPoint = `${path}/send-email`;
  return postData(endPoint, value);
};

export const getAttendanceNotificationApi = () => {
  let endPoint = `${path}/get-attendance-notifications`;
  return fetchData(endPoint);
};

export const renderPdfApi = (data, config = {}) => {
  return postData(`${path}/invoice/pdf`, data, {
    responseType: "blob",
    timeout: 180000, // pdf may take time
    ...config,
  });
};

export const generateInvoiceLinkApi = (data) => {
  return postData(`${path}/invoice/generate-link`, data, {
    timeout: 180000,   // 3 minutes
  });
};


export const uploadInvoicePdfApi = async (blob, fileName) => {
  const formData = new FormData();
  formData.append("document_url", blob, fileName);

  const res = await fetch("/settings/invoice/upload", {
    method: "POST",
    headers: {
      "auth-token": localStorage.getItem("token"),
    },
    body: formData,
  });

  return res.json();
};

export const sendInvoiceEmailApi = async (payload) => {
  return fetch("/settings/invoice/email", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": localStorage.getItem("token"),
    },
    body: JSON.stringify(payload),
  });
  
};


